import type { SVGProps } from 'react';
export const SvgReddit = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<g clipPath="url(#a)">
			<rect width={40} height={40} fill="#FF4500" rx={10} />
			<path
				fill="#FF4500"
				d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
			/>
			<path
				fill="#fff"
				d="M33.333 20a2.925 2.925 0 0 0-2.924-2.924c-.795 0-1.497.304-2.011.819-1.989-1.427-4.749-2.363-7.79-2.48l1.333-6.246 4.328.913c.047 1.1.959 1.988 2.082 1.988a2.087 2.087 0 0 0 2.082-2.082 2.087 2.087 0 0 0-2.082-2.082c-.819 0-1.52.468-1.848 1.17l-4.842-1.03a.58.58 0 0 0-.398.07c-.117.07-.187.188-.234.328l-1.474 6.971c-3.11.094-5.894 1.006-7.906 2.48a2.95 2.95 0 0 0-2.012-.82A2.925 2.925 0 0 0 6.713 20c0 1.193.702 2.199 1.731 2.666-.046.281-.07.585-.07.89 0 4.49 5.217 8.116 11.673 8.116s11.672-3.625 11.672-8.117c0-.304-.023-.584-.07-.865A3.03 3.03 0 0 0 33.333 20m-20 2.082c0-1.146.936-2.082 2.082-2.082s2.082.936 2.082 2.082a2.087 2.087 0 0 1-2.082 2.082 2.086 2.086 0 0 1-2.082-2.082m11.626 5.497c-1.427 1.427-4.14 1.52-4.936 1.52-.795 0-3.532-.117-4.935-1.52a.55.55 0 0 1 0-.772.55.55 0 0 1 .772 0c.889.889 2.807 1.216 4.187 1.216s3.275-.327 4.187-1.216a.55.55 0 0 1 .772 0c.163.234.163.561-.047.772m-.374-3.415a2.086 2.086 0 0 1-2.082-2.082c0-1.146.936-2.082 2.082-2.082s2.082.936 2.082 2.082a2.087 2.087 0 0 1-2.082 2.082"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<rect width={40} height={40} fill="#fff" rx={10} />
			</clipPath>
		</defs>
	</svg>
);
